import React from "react";
import AboutWrapperArea from "./AboutWrapperArea";

function About() {
  return (
    <>
      <section className="info-bg"><AboutWrapperArea/></section>
    </>
  );
}

export default About;
